import React from "react";
import "../assets/css/style.css";
import banner from "../assets/css/img/Banner1-882c0b4b.jpg"
import shock from '../assets/css/img/shock.png'


const Banner = () => {
  return (
    <section id="Subsidy" className="container banner" >
      <div className="row align-items-center ">
      <h1 className=" green-heading text-center mt-5">
          <img src={shock} className="shock" alt="shock-icon" />&nbsp;
           Subsidy
        </h1>
        <div className="col-md-6  "> {/* Center image in column */}
        {/* <h3 className="why-list">
          Register in the portal with the following
           {/* https://www.pmsuryaghar.gov.in/ */}
          {/* </h3> */} 
          <div className="image-container ">
          <a href="https://www.pmsuryaghar.gov.in/" target="_blank" rel="noopener noreferrer">
  <img
    src={banner}
    alt="Solar Panels"
    className="img-fluid rounded shadow-lg"
  />
</a>

          </div>
        </div>
        <div className="col-md-6">
         
          
          <ul className="why-list">
          
          
            <li><strong>Get Loan Upto 90% with PM – Surya Ghar: Muft Bijli Yojana</strong></li>
            <li>PM Surya Ghar: Muft Bijli Yojana is a government scheme that aims to provide free electricity to households in India. The scheme was launched by Prime Minister Narendra Modi on February 15, 2024. Under the scheme, households will be provided with a subsidy to install solar panels on their roofs. The subsidy will cover up to 40% of the cost of the solar panels. The scheme is expected to benefit 1 crore households across India. It is estimated that the scheme will save the government Rs. 75,000 crore per year in electricity costs.</li>
        
          </ul>
          {/* <button className="btn review-button">Know More</button> */}


        </div>
        <div className="d-flex justify-content-center align-items-center  p-3" >
        <table>
              <tr>
                <th className="text-start">Suitable Rooftop <br></br>
                Solar Plant Capacity</th>
                <th>&nbsp;</th>
               <th>&nbsp;</th>
               

                <th className="text-end ">Subsidy Support</th>
              </tr>
              <tr>
                <td>1-2 kW</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td className="text-end ">₹ 30,000/- to ₹60000/-</td>
              </tr>
              <tr>
                <td>2-3 kW</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td className="text-end ml-5">₹ 60,000/- to ₹78000/-</td>
              </tr>
              <tr>
                <td>Above 3 kW</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td className="text-end "> ₹78000/-</td>
              </tr>
            </table>
            </div>
            <div className="banner-link mb-5">
          Visit &nbsp;
  <a
    href="https://www.pmsuryaghar.gov.in/"
    target="_blank"
    rel="noopener noreferrer"
   
  >
  https://www.pmsuryaghar.gov.in/ 
  </a>
  &nbsp;and select Axis Solar Systems for further Process
  </div>

      </div>
    </section>
  );
};

export default Banner;
